import script from "./CardView.vue?vue&type=script&setup=true&lang=js"
export * from "./CardView.vue?vue&type=script&setup=true&lang=js"

import "./CardView.vue?vue&type=style&index=0&id=05f11308&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f11308"]])

export default __exports__